"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNursysLookupResultCreateDto = instanceOfNursysLookupResultCreateDto;
exports.NursysLookupResultCreateDtoFromJSON = NursysLookupResultCreateDtoFromJSON;
exports.NursysLookupResultCreateDtoFromJSONTyped = NursysLookupResultCreateDtoFromJSONTyped;
exports.NursysLookupResultCreateDtoToJSON = NursysLookupResultCreateDtoToJSON;
exports.NursysLookupResultCreateDtoToJSONTyped = NursysLookupResultCreateDtoToJSONTyped;
/**
 * Check if a given object implements the NursysLookupResultCreateDto interface.
 */
function instanceOfNursysLookupResultCreateDto(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function NursysLookupResultCreateDtoFromJSON(json) {
    return NursysLookupResultCreateDtoFromJSONTyped(json, false);
}
function NursysLookupResultCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'],
    };
}
function NursysLookupResultCreateDtoToJSON(json) {
    return NursysLookupResultCreateDtoToJSONTyped(json, false);
}
function NursysLookupResultCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'],
    };
}
//# sourceMappingURL=NursysLookupResultCreateDto.js.map